import { render, staticRenderFns } from "./listnews.vue?vue&type=template&id=284b437a&"
import script from "./listnews.vue?vue&type=script&lang=js&"
export * from "./listnews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports